import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import AuthBase from './components/AuthBase'
import AuthLogin from './components/AuthLogin'

const authRoutes = (
  <Route
    component={AuthBase}
    key="auth-routes"
    path={getPath('backend', '/login')}
  >
    <IndexRoute
      component={AuthLogin}
    />
  </Route>
)

export default authRoutes



// WEBPACK FOOTER //
// ./src/auth/routes.js